import apiRequestHeaders from '../apiRequestHeaders';
import axiosInstance from './axiosInstance';

export interface DistributionChannel {
  id: string;
  name: string;
  slug: string;
  description?: string;
  isActive?: boolean;
}

export interface AccommodationIcalImport {
  id?: string;
  sourceUrl: string;
  fetchCount: number;
  feedStatus: string | number;
  importedAtUtc?: string | null;
  successfulImportAtUtc?: string | null;
  isActive: boolean;
  accommodationId: string;
  distributionChannelId: string;
}

export interface AccommodationIcalExport {
  id?: string;
  feedPublicId: string;
  requestCount: number;
  lastRequestIp?: string | null;
  feedStatus: string | number;
  exportedAtUtc?: string | null;
  successfulExportAtUtc?: string | null;
  isActive: boolean;
  accommodationId: string;
  distributionChannelId: string;
  exportUrl?: string | null;
}

export interface SaveImportPayload {
  id?: string;
  accommodationId: string;
  distributionChannelId: string;
  sourceUrl: string;
  isActive: boolean;
}

export interface SaveExportPayload {
  id?: string;
  accommodationId: string;
  distributionChannelId: string;
  isActive: boolean;
}

export interface IcalDataResponse {
  distributionChannels: DistributionChannel[];
  imports: AccommodationIcalImport[];
  exports: AccommodationIcalExport[];
}

const config = {
  headers: {
    ...apiRequestHeaders.csrfHeader(),
    ...apiRequestHeaders.activeSiteHeader(),
  },
};

export function fetchDistributionChannels() {
  return axiosInstance
    .get('/ical/distribution-channels', config)
    .then(res => res.data);
}

export function fetchIcalImports(accommodationId: string) {
  return axiosInstance
    .get('/ical/imports', {
      ...config,
      params: { accommodationId },
    })
    .then(res => res.data);
}

export function fetchIcalExports(accommodationId: string) {
  return axiosInstance
    .get('/ical/exports', {
      ...config,
      params: { accommodationId },
    })
    .then(res => res.data);
}

export function saveIcalImport(payload: SaveImportPayload) {
  return axiosInstance
    .post('/ical/saveImport', payload, config)
    .then(res => res.data);
}

export function saveIcalExport(payload: SaveExportPayload) {
  return axiosInstance
    .put('/ical/saveExport', payload, config)
    .then(res => res.data);
}

export function deleteIcalImport(importId: string) {
  return axiosInstance
    .delete(`/ical/deleteImport/${importId}`, config)
    .then(res => res.data);
}

export function deleteIcalExport(exportId: string) {
  return axiosInstance
    .delete(`/ical/deleteExport/${exportId}`, config)
    .then(res => res.data);
}

export function triggerIcalImport(
  accommodationNumber: number,
  distributionChannelId?: string,
) {
  const url = distributionChannelId
    ? `/ical/import/${accommodationNumber}?distributionChannelId=${distributionChannelId}`
    : `/ical/import/${accommodationNumber}`;
  return axiosInstance.post(url, {}, config).then(res => res.data);
}
